/**
 * 共通カラー定数
 * アプリケーション全体で使用する色の定義
 * プリセットから読み込み、環境変数VITE_CONTRAST_MODEで切り替え可能
 */

import { activePreset } from './colorPresets';

/** ベースカラー */
export const BASE_COLORS = activePreset.base;

/** テーマカラー（Ant Design準拠） */
export const THEME_COLORS = activePreset.theme;

/** ダークテーマカラー */
export const DARK_THEME = activePreset.darkTheme;

/** ステータスカラー */
export const STATUS_COLORS = activePreset.status;

/** チャート用カラー */
export const CHART_COLORS = activePreset.chart;

/** ログレベルカラー */
export const LOG_LEVEL_COLORS = activePreset.logLevel;

/** 統計カードカラー */
export const STATISTIC_COLORS = activePreset.statistic;

/** フィードバック用背景色 */
export const FEEDBACK_BACKGROUND_COLORS = activePreset.feedbackBackground;

/**
 * カラーユーティリティ
 */
export const ColorUtils = {
  /**
   * 透明度を適用した色を返す
   */
  withOpacity: (color: string, opacity: number): string => {
    const validOpacity = Math.max(0, Math.min(1, opacity));
    return `${color}${Math.floor(validOpacity * 255).toString(16).padStart(2, '0')}`;
  },

  /**
   * Hex色をRGBA形式に変換
   */
  hexToRgba: (hex: string, alpha: number = 1): string => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  },
} as const;

/**
 * 型定義
 */
export type BaseColor = typeof BASE_COLORS[keyof typeof BASE_COLORS];
export type ThemeColor = typeof THEME_COLORS[keyof typeof THEME_COLORS];
export type DarkThemeColor = typeof DARK_THEME[keyof typeof DARK_THEME];
export type StatusColor = typeof STATUS_COLORS[keyof typeof STATUS_COLORS];
export type ChartColor = typeof CHART_COLORS[keyof typeof CHART_COLORS];
export type LogLevelColor = typeof LOG_LEVEL_COLORS[keyof typeof LOG_LEVEL_COLORS];
export type StatisticColor = typeof STATISTIC_COLORS[keyof typeof STATISTIC_COLORS];
export type FeedbackBackgroundColor = typeof FEEDBACK_BACKGROUND_COLORS[keyof typeof FEEDBACK_BACKGROUND_COLORS];
